import type {EventDocument} from 'prismicio-types'
import type {FC} from 'react'
import {BaseEventsCarousel} from '../BaseEventsCarousel'
import {EventCard} from '../EventCard'

type RelatedEventsCarouselProps = {
  events: EventDocument[]
  labels: {
    watchButton: string
    registerButton: string
  }
}

export const RelatedEventsCarousel: FC<RelatedEventsCarouselProps> = ({events, labels}) => (
  <BaseEventsCarousel<EventDocument>
    items={events}
    renderSlide={(event, _index, isActive) => <EventCard event={event} isActive={isActive} labels={labels} />}
    getSlideKey={(_event, index) => index}
    swiperWrapperClassName="w-full px-5 md:px-10 lg:mx-auto lg:max-w-[1200px] lg:px-5 xl:px-0"
    controlsClassName="box-border rounded-4 bg-moss-grey-100 pb-8 pt-6 md:pt-8"
    containerClassName="gap-0"
  />
)
